<template>
  <component
    :is="tag"
    class="play-navbar"
    :class="{ 'play-navbar--sticky': sticky, 'play-navbar--bordered': bordered }"
  >
    <slot />
  </component>
</template>

<script>
/**
 * PlayNavbar — top navigation bar shell for the Play system.
 *
 * Token-driven (see src/styles/tokens.scss). Replaces bootstrap-vue's
 * <b-navbar>. A flex bar that holds a brand + one or more <PlayNav> groups.
 * `sticky` pins it to the top; `bordered` adds the bottom hairline.
 *
 * VUE3-MIGRATION: nothing Vue 2-specific — already Vue 3-safe.
 */
export default {
  name: 'PlayNavbar',
  props: {
    tag: {
      type: String,
      default: 'nav',
    },
    sticky: {
      type: Boolean,
      default: false,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.play-navbar {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 12px 20px;
  background: var(--surface-card);

  &--sticky {
    position: sticky;
    top: 0;
    z-index: 1030;
  }

  &--bordered { border-bottom: var(--border-w) solid var(--border-ink); }
}
</style>
